import { useEffect, useMemo } from "react"

import { honeybadger } from "shared/api/honeybadger/honeybadger.config"
import { useUserRolesQuery } from "shared/api/user-space/queries.generated"
import { AuthContextType } from "shared/context/AuthContext"
import { UserRole } from "shared/types/UserInfo"

import { useLoginStatus } from "widgets/auth-provider/model/login-store"

import { useLogin } from "./useLogin"
import { useLoginSession } from "./useLoginSession"

export function useAuthProvider(): AuthContextType {
  const isLoggedIn = useLoginStatus()

  const { userInfo, isLoading } = useLoginSession()
  const { data: userRoles } = useUserRolesQuery({ skip: !isLoggedIn })

  useEffect(() => {
    honeybadger.setContext({
      user_id: userInfo?.id,
      user_email: userInfo?.email
    })
  }, [userInfo?.id])

  const { login, logout } = useLogin({
    isAuthenticated: !!isLoggedIn
  })

  const userInfoWithRoles = useMemo(() => {
    return userInfo
      ? {
          ...userInfo,
          email: userRoles?.userRoles?.email || userInfo.email,
          name: userRoles?.userRoles?.name || userInfo.name,
          roles: (userRoles?.userRoles?.roles ?? []) as UserRole[]
        }
      : null
  }, [userInfo, userRoles])

  return {
    userInfo: userInfoWithRoles ?? null,
    isAuthenticated: !!isLoggedIn,
    isLoading,
    login,
    logout
  }
}
